export default __webpack_public_path__ + "static/natureMobile-5a2e02796a74f5d1665fe1bc8e7da3a0.svg";